// UTILITAIRES EN VRAC

export function getEnv() {
    switch(location.hostname) {
	case 'vitroto.fr':
	case 'www.vitroto.fr':
	case 'vps-ee7fed3b.vps.ovh.net':
	    return 'prod';
	case 'dev.vitroto.fr':
	case 'test.vitroto.fr':
	case 'vps235287.ovh.net':
	    return 'dev';
	default:
	    throw 'utils.getEnv(): check hostname: ' + location.hostname;
    }
};

export function genRandStr(len) {
    // Timestamp's based for ordering
    len = len || 40;
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var text = '';
    for (var i = 0; i < len; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    // Ou:
    //text = Math.random().toString(36).substr(2,11);	    // 10 ou 11 chars

    return text;
};

export function nl2br(str) {
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
};

// Merci underscore
export function debounce(func, wait, immediate) {
    var timeout;
    return function() {
	var context = this, args = arguments;
	var later = function() {
	    timeout = null;
	    if (!immediate) func.apply(context, args);
	};
	var callNow = immediate && !timeout;
	clearTimeout(timeout);
	timeout = setTimeout(later, wait);
	if (callNow) func.apply(context, args);
    };
};

// Ordonner un tableau d'objet en fonction d'une clef
export function orderArray(array, key, sens, lowercase) {
    sens = sens || 'asc';
    lowercase = lowercase || false;

    var length = array.length - 1, done, i, j;
    for (i = 0; i < length; i++) {
	done = true;
	for (j = 0; j < length; j++) {
	    var item1 = array[j], item2 = array[j+1];
	    var value1 = item1[key], value2 = item2[key];
	    if (lowercase) { value1 = value1.toLowerCase(); value2 = value2.toLowerCase(); }
	    if ( (sens === 'asc' && value1 > value2) || (sens === 'desc' && value1 < value2) ) {
		array[j] = item2;
		array[j+1] = item1;
		done = false;
	    }
	}
	if (done) break;
    }
};

// Echapper le html
export function escapeHtml(html) {
    var htmlEscapes = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#x27;',
	'/': '&#x2F;'
    };
    var htmlEscaper = /[&<>"'\/]/g;
    return ('' + html).replace(htmlEscaper, function(match) {
	return htmlEscapes[match];
    });
}

// https://stackoverflow.com/questions/10158190/how-to-set-cursor-at-the-end-in-a-textarea
export function moveCursorToEnd(el) {
    if (typeof el.selectionStart == "number") {
        el.selectionStart = el.selectionEnd = el.value.length;
    } else if (typeof el.createTextRange != "undefined") {
        el.focus();
        var range = el.createTextRange();
        range.collapse(false);
        range.select();
    }
}

export function isObject(o) {
    return ['object', 'function'].includes(typeof o) && o !== null;
}
